import React from 'react';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import Text from '../../../ui/Text/Text';
import Input from '../../../ui/Input/Input';
import Button from '../../../ui/Button/Button';
import useDeviceTypeDetector from '../../../hooks/useDeviceTypeDetector/useDeviceTypeDetector';

import {
  InvalidEmailErrorMessage,
  InvalidPhoneErrorMessage,
  phoneRegExp,
  RequiredErrorMessage,
} from '../../../utils/constants';
import { useAccessibility } from '../../../contexts/AccessibilityContext';
import { iconSrcMap } from './EnrollmentForm.constants';

type TFormInputs = {
  name: string;
  email: string;
  phone: string;
};

const EnrollmentForm = () => {
  const { isDesktop } = useDeviceTypeDetector();
  const {
    settings: { theme },
  } = useAccessibility();

  const enrollmentFormSchema = Yup.object().shape({
    name: Yup.string().required(RequiredErrorMessage),
    email: Yup.string().email(InvalidEmailErrorMessage).required(RequiredErrorMessage),
    phone: Yup.string()
      .required(RequiredErrorMessage)
      .matches(phoneRegExp, InvalidPhoneErrorMessage),
  });

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<TFormInputs>({
    resolver: yupResolver(enrollmentFormSchema),
    shouldFocusError: true,
  });

  // eslint-disable-next-line no-console
  const onSubmit = (data: TFormInputs) => console.log(data);

  const controlSize = isDesktop ? 'large' : 'small';

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Input
        iconName={iconSrcMap.user[theme]}
        placeholder='Имя'
        variant='secondary'
        size={controlSize}
        message={errors.name?.message}
        hasError={!!errors.name?.message}
        {...register('name', { required: true })}
      />
      <Input
        placeholder='Email'
        variant='secondary'
        iconName={iconSrcMap.envelopeSimple[theme]}
        size={controlSize}
        message={errors.email?.message}
        hasError={!!errors.email?.message}
        {...register('email', { required: true })}
      />
      <Input
        variant='secondary'
        iconName={iconSrcMap.phoneCall[theme]}
        placeholder='Телефон'
        size={controlSize}
        message={errors.phone?.message}
        hasError={!!errors.phone?.message}
        {...register('phone', { required: true })}
      />
      <Button fullWidth type='submit' variant='tertiary' size={controlSize}>
        <Text variant='body1' fontWeight={600}>
          Купить
        </Text>
      </Button>
      <Text variant='body2' className='policy'>
        Оставляя заявку, ты принимаешь условия{' '}
        <a href={window.location.href}>Политики конфиденциальности</a>
      </Text>
    </form>
  );
};

export default EnrollmentForm;
